// ***********************************************
//  인증
// ***********************************************
import React, { createContext, useContext, useReducer } from "react";


// -----------------------------------------------
//  액선 타입 정의
// -----------------------------------------------
export const LOGIN = "auth/LOGIN";
export const LOGOUT = "auth/LOGOT";

// -----------------------------------------------
//  초기 상태
// -----------------------------------------------
const initialState = {
  loggedIn: false,
  loggedUser: {
    displayName: undefined,
    roler: undefined,
    accessToken: undefined,
    refreshToken: undefined,
  },
};

// -----------------------------------------------
//  리듀서 함수
// -----------------------------------------------
// axios 헤드에 인증 설정
const setAuthorization = (accessToken) => {
  // console.log("setAuthorization : ", accessToken);
  // axios.defaults.headers.common[
  //   "Authorization" // 인증
  // ] = `Bearer ${accessToken}`;
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      //console.log("AuthContext:LOGIN ", action);
      const { displayName, roler, accessToken, refreshToken } =
        action.loggedUser;

      // axios 헤드에 인증 설정
      setAuthorization(accessToken);

      // 로컬 스토리지에 저장
      window.localStorage.setItem("biggame-loggedIn", true);
      window.localStorage.setItem("biggame-displayName", displayName);
      window.localStorage.setItem("biggame-roler", roler);
      // window.localStorage.setItem("biggame-accessToken", accessToken);
      // window.localStorage.setItem("biggame-refreshToken", refreshToken);

      return {
        ...state,
        loggedIn: true,
        loggedUser: {
          displayName,
          roler,
          accessToken,
          refreshToken,
        },
      };
    case LOGOUT:
      //console.log("AuthContext:LOGOUT ", action);
      window.localStorage.setItem("biggame-logout", Date.now());
      setAuthorization(null);

      // 로컬 스토리지에 제거
      window.localStorage.setItem("biggame-loggedIn", false);
      window.localStorage.setItem("biggame-displayName", null);
      window.localStorage.setItem("biggame-roler", null);
      window.localStorage.setItem("biggame-accessToken", null);
      window.localStorage.setItem("biggame-refreshToken", null);

      return {
        ...state,
        loggedIn: false,
        loggedUser: {
          displayName: undefined,
          roler: undefined,
          accessToken: undefined,
          refreshToken: undefined,
        },
      };
    default:
      return state;
  }
};

// -----------------------------------------------
//  Context
// -----------------------------------------------
const AuthStateContext = createContext(null);
const AuthDispatchContext = createContext(null);


export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  return (
    <AuthStateContext.Provider value={state}>
      <AuthDispatchContext.Provider value={dispatch}>
        {children}
      </AuthDispatchContext.Provider>
    </AuthStateContext.Provider>
  );
};

export const useAuthState = () => {
  const state = useContext(AuthStateContext);
  if (!state) {
    throw new Error("AuthProvider를 찾지 못 하였습니다.");
  }
  return state;
};

export const useAuthDispatch = () => {
  const dispatch = useContext(AuthDispatchContext);
  if (!dispatch) {
    throw new Error("AuthProvider를 찾지 못 하였습니다.");
  }
  return dispatch;
};
